import { FC, useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MenuItem } from '../../features/layout/types/layout.types';
import NavItem from './NavItem';

interface HamburgerMenuProps {
  modeMenuOptions: MenuItem[];
}

const HamburgerMenu: FC<HamburgerMenuProps> = ({ modeMenuOptions }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex items-center">
      <button className="text-gray-500 focus:outline-none" onClick={toggleMenu}>
        <GiHamburgerMenu className="h-5 w-5" />
      </button>
      {isOpen && (
        <>
          <div className="absolute left-0 top-0 z-20 flex h-full w-1/2 justify-center bg-gray-800 bg-opacity-90">
            <ul className="p-8 text-sm text-white">
              {modeMenuOptions.map(({ title, Icon, selected }) => (
                <li className="mt-4">
                  <NavItem key={title} title={title} Icon={Icon} selected={selected} />
                </li>
              ))}
            </ul>
          </div>
          <div onClick={toggleMenu} className="fixed left-0 top-0 z-10 h-full w-full bg-black bg-opacity-50" />
        </>
      )}
    </div>
  );
};

export default HamburgerMenu;
